import "./search.css"
import {POSTR, _t, GET, mdi, logError, GETP, POSTP} from "../function.js";
import "../highlight.js";
import {mdiPound, mdiPaperclip, mdiLink, mdiFileDocumentOutline, mdiPost} from "@mdi/js";

/**
 * Заголовок по руководству
 * @type {*}
 */
const title_ug = _t('AqNOS. Руководство')
/**
 * Заголоовок справочника
 * @type {*}
 */
const title_cr = _t('AqNOS. Справочник')
/**
 * Заголовок загрузок
 * @type {*}
 */
const title_download = _t('Загрузки')
/**
 * Заголовок загрузок
 * @type {*}
 */
const title_confl = _t('Страницы')
const ai_warning = _t('* Данная запись получена средствами ИИ, любые галлюцинации ИИ должны быть проверены человеком и их использование на ваш страх и риск')

const btn_close=`<div class="a-search__close link link--black" onclick="$$('win_search').hide()"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 21L3 3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M21.0001 3L3 21.0001" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`

const aq_loader=`
<div class="a-loading-bar">
    <div class="a-loading-bar__overlay"></div>
        <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-circular v-progress-circular--visible v-progress-circular--indeterminate teal--text" style="height: 36px; width: 36px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="22.5 22.5 45 45" style="transform: rotate(0deg);">
                <circle fill="transparent" cx="45" cy="45" r="20" stroke-width="5" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle>
            </svg>
            <div class="v-progress-circular__info">
            </div>
        </div>
    </div>
</div>
`

jqueryts.DataStore.prototype.sorting.as.bylength = function(a,b){
    return a > b ? 1 : -1
}

/**
 * Заголовок сообщений
 * @type {*}
 */
const title_msg = _t('AqNOS. Сообщения')
const title_answer = _t('AqNOS. AI')

let is_admin=false;
if (window.config.auth.code===0)
    if (window.config.auth.id_category===1)
        is_admin=true;
/**
 * Интервал обновления iframe sphinx
 * @type {number}
 */

/**
 * Конфигурация
 * @type {object}
 */
const config = window.config;
const iconPound = mdi(mdiPound, "#999")
const iconPaperclip = mdi(mdiPaperclip, "#ccc")
const iconLink = mdi(mdiLink, "#ccc")
const iconPost = mdi(mdiPost, "#ccc")
const iconFileDocumentOutline = mdi(mdiFileDocumentOutline, "#ccc")

/**
 * Режим темы
 * @type {boolean}
 */
let dark = false

/**
 * Минимальная высота iframe sphinx
 * @type {number}
 */
let minHeight = window.outerHeight / 2 - 70
/**
 * Текущий язык
 * @type {*|jQuery}
 */
const lang = $("html").attr("lang")
/**
 * Расчетная ширина окна поиска
 * @type {number}
 */
let win_with_search = 940

/**
 * Тип поиска мобильный / десктопный
 * @type {string}
 */
let type = 'desc'
let type_app = 'desc'

/**
 * Мобильный режим
 */
let mobile=false
if (document.body.offsetWidth <= 1024) {
    win_with_search = window.outerWidth - 20
    type = 'mob'
    type_app = 'mob'
    minHeight = 70
    mobile=true
}

const text_not_found = `
<div class="not_found_parent">
        <div class="not_found">
            <h3 class="text-lg">${_t('Страницы, содержащие слова запроса, в разделе не найдены.')}</h3>
            <p class="text-xs font-light">${_t('По запросу <b>{{text}}</b> ничего не найдено.')}</p>

            <p class="text-xs font-light">${_t('Рекомендации')}:</p>

            <ul>
                <li class="text-gray">${_t('Убедитесь, что все слова написаны без ошибок.')}</li>
                <li class="text-gray">${_t('Попробуйте использовать другие ключевые слова.')}</li>
                <li class="text-gray">${_t('Попробуйте использовать более популярные ключевые слова.')}</li>
                <li class="text-gray">${_t('Попробуйте уменьшить количество слов в запросе.')}</li>
            </ul>
        </div>
        <div class="{{not_found_img}}"></div>
</div>
`
/**
 * Модель директорий для поиска
 * @type {jqueryts.DataCollection}
 */
export const cat_search = new jqueryts.DataCollection({
    data: []
})

/**
 * Инициализация для дозагрузки категорий файлов для поиска и переводов
 * @type {boolean}
 */
let init_search = false

jqueryts.ready(function () {
    /**
     * Расчет активной вкладки поиска
     * @type {string[]}
     */
    let path_arr = window.location.pathname.split("/")
    let redirect = false
    /**
     * Модально окно поиска
     */
    const config={
        view: "window",
        id: "win_search",
        animate: false,
        css: "win_auth bg win_search",
        escHide: true,
        width: win_with_search,
        borderless: true,
        move: false,
        height: window.outerHeight-300,
        modal: true,
        head: false,
        body: {
            css: "v-aq-search-tr",
            type:"clean",
            borderless: true,
            rows: [
                {
                    css: "v-aq-search-tr title_1",
                    height: 60,
                    template:  `<div class="title_search">${_t("Поиск по сайту AqNOS")}</div>`,
                    id: "title_1",
                    borderless: true,
                },
                {
                    css: "v-aq-search-block",
                    type: "clean",
                    padding:{
                        top:15, bottom:3, left:15, right:15
                    },
                    borderless: true,
                    cols: [
                        {
                            width: 1,
                            borderless: true,
                            template:`<div id='v-aq-search-border'></div>`,
                        },
                        {
                            view: `template`,
                            id: "ai-loader",
                            width: 50,
                            borderless: true,
                            template:  (obj)=> {
                                let icon = `<div class='aq-search-icon'><span class="jqueryts_icon wxi-search"></span></div>`
                                if (obj.state==='ai-show')
                                    icon=`<div class='ai-loader'><span></span></div>`
                                return icon
                            },
                            data: {
                                "state": "search"
                            }
                        },
                        {
                            css: "v-aq-search search-text",
                            id: "search_txt",
                            view: "text",
                            placeholder: "Поиск по порталу документации",
                            keyPressTimeout: 100,
                            on: {
                                onKeyPress: function (code, e) {
                                    try {
                                        // console.log(code)
                                        if (code === 13) {
                                            redirect=true
                                            search($$("search_txt").getValue(), 3,  "href")
                                        }
                                    } catch (e) {
                                        // console.error(e)
                                    }
                                },
                                onTimedKeyPress: function (){
                                    search($$("search_txt").getValue(), 3,  "hint")
                                },
                            }
                        },
                        {
                            view: "button",
                            width: 120,
                            height: 45,
                            css: "v-btn-ts-md",
                            id: "search-button",
                            value: _t("Найти"),
                            on: {
                                onItemClick: () => {
                                    try {
                                        redirect=true
                                        search($$("search_txt").getValue(), 2, "href")
                                    } catch (e) {
                                        logError(e)
                                    }
                                }
                            }
                        },
                    ]
                },
                {
                    view: `template`,
                    id: "ai-informer",
                    height: 20,
                    type:"clean",
                    borderless: true,
                    template:  (obj)=> {
                        let text =``
                        if (obj.state==="run")
                            text = `<small>Запущен дополнительный поиск с использованием искусственного интеллекта...</small>`
                        if (obj.state==="no-result")
                            text = `<small>Поиск с использованием искусственного интеллекта результатов не дал</small>`
                        if (obj.state==="result")
                            text = `<small>Поиск с использованием искусственного интеллекта дополнил объекты результатов поиска на <b>${obj.count}</b></small>`
                        return `<div class="ia-informer">${text}</div>`
                    },
                    data: {
                        "state": "none",
                        "count": 0
                    }
                },
                {
                    type:"clean",
                    borderless: true,
                    hidden:!is_admin,
                    cols: [
                        {},
                        {
                            autoheight:true,
                            type:"clean",
                            borderless: true,
                            width: 150,
                            css: "",
                            template: `<small><a class="link" target="_blank" href="https://aistudio.yandex.ru/platform/folders/${window.config.ai_ya.folder_id}/agents/${window.config.ai_ya.agent_id}">Настройка агента ИИ</a></small>`,
                        },
                    ]
                },
                {
                    css: "v-aq-search-tr",
                    height: 70,
                    id: "title_2",
                    type:"clean",
                    borderless: true,
                },
                {
                    id: "search_block",
                    autoheight: true,
                    // height: true,
                    // height: 500,
                    height: window.outerHeight-600,
                    hidden: true,
                    type:"clean",
                    borderless: true,
                    rows: [
                        {
                            id: "search_part",
                            template: (obj) => {
                                try {
                                    let tag_aq_ug = `<div id="tag_aq_ug" onclick="window.search_filter('aqnos_ug')"><i class="icon_tag">${iconPound}</i> <span>${title_ug}</span> <b>${obj.count_ug}</b></div>`
                                    let tag_aq_cr = `<div id="tag_aq_cr" onclick="window.search_filter('aqnos_cr')"><i class="icon_tag">${iconPound}</i> <span>${title_cr}</span> <b>${obj.count_cr}</b></div>`
                                    let tag_files = `<div id="tag_files" onclick="window.search_filter('files')"><i class="icon_tag">${iconPound}</i> <span>${title_download}</span> <b>${obj.count_file}</b></div>`
                                    let tag_confl = `<div id="tag_confl" onclick="window.search_filter('confl')"><i class="icon_tag">${iconPound}</i> <span>${title_confl}</span> <b>${obj.count_confl}</b></div>`
                                    let tag_msg   = `<div id="tag_msg" onclick="window.search_filter('msg')"><i class="icon_tag">${iconPound}</i> <span>${title_msg}</span> <b>${obj.count_msg}</b></div>`
                                    let tag_answer   = `<div id="tag_answer" onclick="window.search_filter('answer')"><i class="icon_tag">${iconPound}</i> <span>${title_answer}&nbsp;&nbsp;</span> </div>`
                                    if (obj.count_cr == 0) tag_aq_cr = ''
                                    if (obj.count_ug == 0) tag_aq_ug = ''
                                    if (obj.count_file == 0) tag_files = ''
                                    if (obj.count_confl == 0) tag_confl = ''
                                    if (obj.count_msg == 0) tag_msg = ''
                                    if (obj.count_answer_ai == 0) tag_answer = ''

                                    return `
                                        <div class="aq_tag_search">
                                            ${tag_aq_ug} ${tag_aq_cr} ${tag_files} ${tag_confl} ${tag_msg} ${tag_answer}
                                        </div>
                                        `
                                } catch (e) {
                                    logError(e)
                                }
                            },
                            data: {
                                count_ug: 0,
                                count_cr: 0,
                                count_file: 0,
                                count_confl: 0,
                                count_msg: 0,
                                count_answer_ai: 0,
                            },
                            autoheight: true
                        },
                        {
                            view:"scrollview",
                            id:"scrollview-search",
                            height: window.outerHeight-670,
                            scroll:"y",
                            // height: 160,
                            body:{
                                rows:[
                                    {
                                        view: "datatable",
                                        id: `search_table`,
                                        css: "aqnos_datatable aqnos_datatable_search",
                                        type: "clean",
                                        borderless: true,
                                        header: false,
                                        fixedRowHeight: false,
                                        rowLineHeight: 20,
                                        rowHeight: 20,
                                        scrollX: false,
                                        scrollY: false,
                                        autoheight: true,
                                        columns: [
                                            {
                                                id: "title",
                                                fillspace: true,
                                                template: (obj) => {
                                                    try {
                                                        let title = ''
                                                        if (obj.type === 'sphinx') {
                                                            if (obj.name === 'aqnos_cr') title = title_cr
                                                            if (obj.name === 'aqnos_ug') title = title_ug
                                                        }
                                                        if (obj.type === 'files')  title=title_download
                                                        if (obj.type === 'confl')  title=title_confl
                                                        if (obj.type === 'msg')    title=title_msg
                                                        const search_txt = $$("search_txt").getValue()
                                                        if (obj.type === 'sphinx') {
                                                            let href=`/${lang}/index/sphinx/${obj.name}_${lang}/${obj.version}/${obj.href}?highlight=${search_txt}`
                                                            let desc = []
                                                            obj.desc.map((el, key) => {
                                                                if (key <= 4) {
                                                                    desc.push(el)
                                                                }
                                                            })
                                                            let desc_data=``
                                                            if (desc.length>0) {
                                                                desc_data=`<br><a href="${href}" class="title_search_body">${desc.join('<br>')}</a>`
                                                            }
                                                            let admin_data = ``
                                                            if (window.config.auth.code === 0)
                                                                if (window.config.auth.id_category === 1) {
                                                                    admin_data = `<br><small style="font-style: italic">Вес поиска: ${obj.rank}</small>`
                                                                }
                                                            return `
<span class="search-row-res">
<span class="sub-title-search">${title}:</span>
<a href="${href}" class="title_search_result">${light_text(obj.title)}</a>
${desc_data}
${admin_data}
<br>&nbsp;
</span>
`
                                                        }
                                                        if (obj.type === 'confl') {
                                                            let href=`/${lang}/index/confl/${obj.name}?highlight=${search_txt}`
                                                            let desc = []
                                                            obj.desc.map((el, key) => {
                                                                if (key <= 4) {
                                                                    desc.push(el)
                                                                }
                                                            })
                                                            let desc_data=``
                                                            if (desc.length>0) {
                                                                desc_data=`<br><a href="${href}" class="title_search_body">${desc.join('<br>')}</a>`
                                                            }
                                                            let admin_data = ``
                                                            if (window.config.auth.code === 0)
                                                                if (window.config.auth.id_category === 1) {
                                                                    admin_data = `<br><small style="font-style: italic">Вес поиска: ${obj.rank}</small>`
                                                                }
                                                            return `
<span class="search-row-res">
<span class="sub-title-search">${title}:</span>
<a href="${href}"  class="title_search_result">${light_text(obj.title)}</a>
${desc_data}
${admin_data}
<br>&nbsp;
</span>
`
                                                        }
                                                        if (obj.type === "files") {
                                                            let cats = []
                                                            obj.id_cat.map(ct => {
                                                                ct = cat_search.getItem(ct)
                                                                cats.push(`
                                                    <a href="/${lang}/index/files/${ct.link}?highlight=${search_txt}" class="link">${light_text(_t(ct.name))}</a>`)
                                                            })
                                                            let admin_data = ``
                                                            if (window.config.auth.code === 0)
                                                                if (window.config.auth.id_category === 1) {
                                                                    admin_data = `<br><small style="font-style: italic">Вес поиска: ${obj.rank}</small>`
                                                                }
                                                            return `
<span class="search-row-res">
<span class="sub-title-search">${title}:</span>
<a href="${obj.file.url}" class="title_search_result"  download="${obj.file.file}" >
    ${light_text(_t(obj.file.name))}
</a>

<span class="title_search_body">
    ${light_text(_t(obj.file.desc))}<br>
    <b>${_t('В загрузках')}:</b>
        ${cats.join(', ')} 
</span>

${admin_data}
<br>&nbsp;
</span>
                                                `
                                                        }

                                                        if (obj.type === 'msg') {
                                                            let message_type = ``
                                                            if (obj.message_type) {
                                                                message_type = `<span class="msg_type t_${obj.message_type}">${light_text(obj.message_type)}</span>&nbsp;`
                                                            }
                                                            let msg_admin = ``
                                                            let ai_agent = ``
                                                            if (obj.id_agent === 1) {
                                                                ai_agent = `<br><span class="msg_agent">${ai_warning}</span>`
                                                            }

                                                            if (window.config.auth.code === 0)
                                                                if (window.config.auth.id_category === 1) {
                                                                    msg_admin = `
<span class="msg_admin">
    Вес поиска: ${obj.rank}<br>
    Данные модуля: <a class="link" href="${obj.module_href}" target="_blank">${obj.module_href}</a><br>
    Функция: ${obj.function_name}<br>
    Макрос: ${obj.macro_name}<br>
    Путь: ${obj.file_path}<br>
    Линия: ${obj.line_no}
</span>
`
                                                                }
                                                            return `
<span class="msg">

    <span class="msg_content">
         ${message_type}
        <code class="message_text">${light_text(obj.message_text)}</code>
        <br>
        <span class="msg_content_text">Описание: <span>${light_text(obj.description_ru)}</span>&nbsp;</span>
        <br>
        <span class="msg_content_text">Рекомендация: <span>${light_text(obj.recommendation_ru)}</span>&nbsp;</span>
        <br>
        <span class="msg_content_text">Модуль: ${light_text(obj.module_code)} - &nbsp;<span>${light_text(obj.module_desc)}</span></span>
        ${ai_agent}
    </span>
    ${msg_admin}
</span>
`
                                                        }

                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                ]
                            }
                        },

                        {
                            id: `search_info`,
                            template: `#mess#`,
                            data: {
                                mess: `<div class="frame_null" style="height: 400px"></div>`
                            },
                            height: 400,
                        },

                    ]
                },
                {
                    cols:[
                        {
                            id: "button_all_search",
                            css:"href_button",
                            template: (obj)=>{
                                if (obj.id===null) return ``
                                return `
                                <a href="/${lang}/index/search/${obj.id}">
                                    <span class="v-btn__content">Все результаты</span>
                                </a>
                            `
                            },
                            data: {
                                id: null
                            },
                            autoheight: true,
                            width: 160,
                            borderless: true
                        },
                        {

                        }
                    ],
                },
            ],
        },
        on: {
            onHide: () => {
                $('html').css("overflow", "auto")
                $('div.jqueryts_modal').removeClass("jqueryts_modal_search")
                $('.a-search__close').remove()
            },
            onShow: () => {
                try {
                    $('html').css("overflow", "hidden")
                    $('div.jqueryts_modal').addClass("jqueryts_modal_search")
                    if (!mobile) $('div.jqueryts_modal').append(btn_close)
                    if (mobile)$('div.title_search').append(btn_close)

                    $$("search_txt").focus()
                    if (!init_search) {
                        init_search = true
                        search_ready()
                    }
                } catch (e) {
                    logError(e)
                }
            }
        }
    }
    if (mobile) config.height = window.outerHeight
    jqueryts.ui(config)
    // jqueryts.extend($$("search_block"), jqueryts.ProgressBar);
    jqueryts.extend($$("search_block"), jqueryts.OverlayBox);

    /**
     * Событие перерасчета высот iframe sphinx
     */
    if ($$("tabview_search"))
        $$("tabview_search").getTabbar().attachEvent("onAfterTabClick", function (id, oldValue, config) {
            if (`aqnos_ug_${type}` === id)
                $$(`aqnos_ug_data_${lang}_${type}`).adjustRowHeight('title', null)
            if (`aqnos_cr_${type}` === id)
                $$(`aqnos_cr_data_${lang}_${type}`).adjustRowHeight('title', null)
        })

    /**
     * Запуск поиска (подгрузка директорий и дозагрузка переводов для файлов)
     */
    function search_ready() {
        /**
         * Дозагрузка категорий файлов
         */
        POSTP(`data/cat_level`, {level: 3}).then(res => {
            try {
                res = res.map(el => {
                    return {
                        id: el.id_cat,
                        name: el.name,
                        link: el.link
                    }
                })
                cat_search.parse(res)
            } catch (e) {
                logError(e)
            }
        })
        /**
         * Дозагрузка переводов для файлов
         */
        GETP(`data/translate?id_page=10`, "public").then(res => {
            try {
                res.map(el => {
                    window.translate.add({
                        id: el.index,
                        index: el.index,
                        [lang]: el[lang]
                    })
                })
            } catch (e) {
                logError(e)
            }
        })
    }

    /**
     * Вызов диалога поиска
     */
    // $('.btn_search').click(function (e, d) {
    //     const param={
    //         x: (document.body.offsetWidth - win_with_search) / 2,
    //         y: 217
    //     }
    //     if (mobile) param.y=0
    //     if (mobile) param.pos="top"
    //     $$("win_search").show(param)
    // })

    // клик по ссылке в алфавитном указателе
    $('a[href="search.html"]').click(function (event) {
        try {
            event.preventDefault();
            const param={
                x: (document.body.offsetWidth - win_with_search) / 2,
                y: 217
            }
            if (mobile) param.y=0
            if (mobile) param.pos="top"
            $$("win_search").show(param)
            return false;
        } catch (e) {
            logError(e)
        }
    })

    let xhr_doc = null;
    let xhr_file = null;
    let xhr_confl = null;
    let xhr_msg = null;
    let xhr_msg_ai = null;
    let xhr_search = null;

    /**
     * Функция основного поиска
     * @param search_txt
     * @param max_length
     */
    function search(search_txt, max_length = 3, type="hint") {
        try {
            if (search_txt.length < max_length) {
                $$("title_2").show()
                $$("search_block").hide()
                return false;
            }
            $$("title_2").hide()
            $$("search_block").show()
            if ($("html").hasClass("dark"))
                dark = true
            else
                dark = false

            let count = null

            if (search_txt.trim(' ') !== "") {
                $$(`search_info`).hide()
                $$(`search_table`).hide()
                $$(`search_table`).clearAll()
                $$("search_block").showOverlay(aq_loader);

                if (xhr_search) {
                    xhr_search.abort();
                    console.log("POST search отменен");
                }

                xhr_search = new XMLHttpRequest();
                xhr_search.responseType = 'json';
                xhr_search.open('POST', `/${lang}/data/search_add`);
                xhr_search.setRequestHeader('Prefer', 'return=representation');
                xhr_search.setRequestHeader('X-Custom-Ajax', 'true');
                xhr_search.onload = function () {
                    const res = xhr_search.response;
                    const id_search = res[0]["id_search"];
                    $$("button_all_search").setValues({id: id_search});

                    if (type==="href" || redirect){
                        if (xhr_msg) xhr_msg.abort();
                        if (xhr_confl) xhr_confl.abort();
                        if (xhr_doc) xhr_doc.abort();
                        if (xhr_file) xhr_file.abort();
                        window.location.href = `/${lang}/index/search/${id_search}`;

                        return false;
                    }

                    Promise.all([
                        search_doc(`/${lang}/sphinx/search/${search_txt}`),
                        search_confl(`/${lang}/confl/search/${search_txt}`),
                        search_file(search_txt),
                        search_msg(id_search),
                    ])
                        .then(responses => {
                            try {
                                $$(`search_info`).hide()
                                $$(`search_table`).show()
                                $$("search_block").hideOverlay();
                                // $$("search_block").hideProgress()

                                // console.log(responses[2])
                                const res = []
                                // VLINK[Vlan200]: peer 10.10.10.5 link down
                                // console.log(responses)
                                // Порядок не нарушать!
                                const sphinx_data=responses[0];
                                const sphinx_data_cr = sphinx_data.filter(el => el.name === 'aqnos_cr')
                                const sphinx_data_ug = sphinx_data.filter(el => el.name === 'aqnos_ug')
                                const confl_data=responses[1];
                                const file_data=responses[2];
                                const msg_data= responses[3];
                                console.log(responses[3])

                                $$(`search_table`).parse(confl_data)
                                $$(`search_table`).parse(sphinx_data_ug)
                                $$(`search_table`).parse(sphinx_data_cr)
                                $$(`search_table`).parse(file_data)
                                $$(`search_table`).parse(msg_data)
                                $$(`search_table`).adjustRowHeight(null, null)
                                $$(`search_table`).sort("#rank#","desc","bylength")
                                //
                                // const count_cr = $$(`search_table`).find(el => el.name === 'aqnos_cr')
                                // const count_ug = $$(`search_table`).find(el => el.name === 'aqnos_ug')
                                $$(`search_part`).setValues({
                                    count_cr: sphinx_data_cr.length,
                                    count_ug: sphinx_data_ug.length,
                                    count_file: file_data.length,
                                    count_confl: confl_data.length,
                                    count_msg: msg_data.length,
                                    count_answer_ai: 0
                                })
                                const text_not = text_not_found
                                    .replace(`{{text}}`, $$("search_txt").getValue())
                                    .replace(`{{not_found_img}}`, "not_found_img_dark")
                                let count_all = sphinx_data_cr.length
                                    + sphinx_data_ug.length
                                    + file_data.length
                                    + confl_data.length
                                    + msg_data.length
                                ;
                                // alert(count_all)
                                if (count_all === 0) {
                                    $$(`search_info`).setValues({mess: text_not})
                                    $$(`search_info`).show()
                                    $$(`scrollview-search`).hide()
                                } else {
                                    $$(`search_info`).hide()
                                    $$(`scrollview-search`).show()
                                }
                                $$("search_block").define("height", window.innerHeight-230)
                                $$("search_block").resize()
                                $$("search_table").define("height", window.innerHeight-230)
                                $$("search_table").resize()
                            } catch (e) {
                                logError(e)
                            }
                        })

                };
                xhr_search.onerror = function () {
                    console.error('Ошибка сети search');
                    xhr_search = null;
                    reject(new Error('Произошла сетевая ошибка.'));
                };
                xhr_search.send(JSON.stringify({search: search_txt}));
            } else {
                $$("search_block").hideOverlay(aq_loader);
                $$("title_1").show()
                $$("title_2").show()
                $$("search_block").hide()
            }

        } catch (e) {
            logError(e)
        }
    }



    function search_doc(url) {
        return new Promise((resolve, reject) => {
            try {
                if (xhr_doc) {
                    xhr_doc.abort(); // Отменяем предыдущий запрос
                    console.log("Предыдущий запрос отменен");
                }
                xhr_doc = new XMLHttpRequest();
                xhr_doc.responseType = 'json';
                xhr_doc.open('GET', url);
                xhr_doc.onload = function () {
                    if (xhr_doc.status >= 200 && xhr_doc.status < 300) {
                        resolve(xhr_doc.response.res);
                        xhr_doc = null; // Сбрасываем xhr после завершения
                    } else if (xhr_doc.status === 400) {
                        console.warn('Поисковый запрос имеет не допустимые символы.', xhr_doc.status);
                        resolve([]);
                        xhr_doc = null; // Сбрасываем xhr после завершения
                    } else {
                        console.error('Ошибка запроса:', xhr_doc.status);
                        xhr_doc = null; // Сбрасываем xhr после завершения
                        reject(new Error(`Ошибка запроса: ${xhr_doc.status} ${xhr_doc.statusText}`));
                    }
                };
                xhr_doc.onerror = function () {
                    console.error('Ошибка сети');
                    xhr_doc = null; // Сбрасываем xhr после завершения
                    reject(new Error('Произошла сетевая ошибка.'));
                };
                xhr_doc.send();
            } catch (e) {
                logError(e)
            }
        })
    }

    function search_confl(url) {
        return new Promise((resolve, reject) => {
            try {
                if (xhr_confl) {
                    xhr_confl.abort(); // Отменяем предыдущий запрос
                    console.log("Предыдущий запрос отменен");
                }
                xhr_confl = new XMLHttpRequest();
                xhr_confl.responseType = 'json';
                xhr_confl.open('GET', url);
                xhr_confl.onload = function () {
                    if (xhr_confl.status >= 200 && xhr_confl.status < 300) {
                        resolve(xhr_confl.response.res);
                        xhr_confl = null; // Сбрасываем xhr после завершения
                    } else if (xhr_confl.status === 400) {
                        console.warn('Поисковый запрос имеет не допустимые символы.', xhr_confl.status);
                        resolve([]);
                        xhr_confl = null; // Сбрасываем xhr после завершения
                    } else {
                        console.error('Ошибка запроса:', xhr_confl.status);
                        xhr_confl = null; // Сбрасываем xhr после завершения
                        reject(new Error(`Ошибка запроса: ${xhr_confl.status} ${xhr_confl.statusText}`));
                    }
                };
                xhr_confl.onerror = function () {
                    console.error('Ошибка сети');
                    xhr_confl = null; // Сбрасываем xhr после завершения
                    reject(new Error('Произошла сетевая ошибка.'));
                };
                xhr_confl.send();
            } catch (e) {
                logError(e)
            }
        })
    }

    /**
     * Функция поиска по файлам
     * @param search_txt
     * @returns {Promise<unknown>}
     */
    function search_file(search_txt) {
        return new Promise((resolve, reject) => {
            try {
                if (xhr_file) {
                    xhr_file.abort(); // Отменяем предыдущий запрос
                    console.log("Предыдущий запрос отменен");
                }
                xhr_file = new XMLHttpRequest();
                xhr_file.responseType = 'json';
                xhr_file.open('POST', `/${lang}/files/find_file`);
                xhr_file.onload = function () {
                    if (xhr_file.status >= 200 && xhr_file.status < 300) {
                        resolve(xhr_file.response);
                        const res = xhr_file.response
                        if (res === null) {
                            return false;
                        }
                        if (res.length === 0) {
                            return false;
                        }
                    } else if (xhr_file.status === 400) {
                        console.warn('Поисковый запрос имеет не допустимые символы.', xhr_file.status);
                        resolve([]);
                        xhr_file = null; // Сбрасываем xhr после завершения
                    } else {
                        reject(new Error(`Ошибка запроса: ${xhr_file.status} ${xhr_file.statusText}`));
                    }
                }
                const data = {
                    search_text: search_txt, lang: lang
                }
                const jsonData = JSON.stringify(data)
                xhr_file.onerror = function () {
                    console.error('Ошибка сети');
                    xhr_file = null; // Сбрасываем xhr после завершения
                    reject(new Error('Произошла сетевая ошибка.'));
                };
                xhr_file.send(jsonData);
            } catch (e) {
                logError(e)
            }
        })
    }

    /**
     * Функция поиска по сообщениям
     * @returns {Promise<unknown>}
     * @param id_search
     */
    function search_msg(id_search) {
        return new Promise((resolve, reject) => {
            try {

                if (xhr_msg) {
                    xhr_msg.abort();
                    console.log("Предыдущий запрос отменен");
                }

                xhr_msg = new XMLHttpRequest();
                xhr_msg.responseType = 'json';
                xhr_msg.open('POST', `/${lang}/msg/find_msg`);
                xhr_msg.onload = function () {
                    resolve(xhr_msg.response);
                };

                const jsonData = JSON.stringify({
                    id_search: id_search
                });
                xhr_msg.onerror = function () {
                    console.error('Ошибка сети');
                    xhr_msg = null;
                    reject(new Error('Произошла сетевая ошибка.'));
                };
                xhr_msg.send(jsonData);


            } catch (e) {
                logError(e)
            }
        })
    }

    /**
     * Функция подсветки текста
     * @param text
     * @returns {*|string}
     */
    function light_text(text) {
        try {
            const searchTerm = $$("search_txt").getValue()
            if (!searchTerm) {
                return text;
            }
            if (!text || text === undefined || text === null) {
                return text;
            }
            const textStr = text.toString();

            // Слова > 2 символов (без учёта коротких)
            const words = searchTerm.split(/\s+/).filter(w => w.length > 2);
            if (!words.length) {
                return textStr;
            }

            // 1. Подсветка полной фразы
            const escapedPhrase = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const phraseRegex = new RegExp(escapedPhrase, 'gi');
            let result = textStr.replace(phraseRegex, '<span class="mark">$&</span>');

            // 2. Подсветка отдельных слов (не трогаем уже обёрнутые в mark)
            const segments = result.split(/(<span class="mark">.*?<\/span>)/g);
            const escapedWords = words.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
            const wordRegex = new RegExp(`(${escapedWords.join('|')})`, 'gi');

            result = segments.map(seg => {
                if (seg.startsWith('<span class="mark">')) return seg;
                return seg.replace(wordRegex, '<span class="mark">$1</span>');
            }).join('');

            return result;
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Скрытие окна поиска при нажатии Esc
     */
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            // Здесь напишите код, который будет выполняться при нажатии Escape
            if ($$("win_search")) {
                $$("win_search").hide()
            }
        }
    });
})


window.search_filter = function (type) {
    try {
        $(".aq_tag_search>div").removeClass("active")
        switch (type) {
            case 'aqnos_cr':
                $$('search_table').filter(el => el.name === 'aqnos_cr');
                $('#tag_aq_cr').addClass('active')
                break
            case 'aqnos_ug':
                $$('search_table').filter(el => el.name === 'aqnos_ug');
                $('#tag_aq_ug').addClass('active')
                break
            case 'files':
                $$('search_table').filter(el => el.type === 'files');
                $('#tag_files').addClass('active')
                break
            case 'confl':
                $$('search_table').filter(el => el.type === 'confl');
                $('#tag_confl').addClass('active')
                break
            case 'msg':
                $$('search_table').filter(el => el.type === 'msg');
                $('#tag_msg').addClass('active')
                break
        }
    } catch (e) {
        logError(e)
    }
}